import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'

function renderButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.upload'),
        icon: icons.attach_file,
        mode: buttonModes.flat,
        color: Colors.primary,
        loading: this.isLoading,
        disabled: this.isDisabled
      },
      on: {
        click: this.handleClick
      }
    }
  )
}

function renderTrigger(h) {
  return h(
    'div',
    {
      class: {
        'file-drop__trigger': true,
        'file-drop__trigger--disabled': this.isDisabled
      },
      on: {
        dragover: this.activateDropArea,
        dragleave: this.deactivateDropArea,
        dragend: this.deactivateDropArea,
        drop: this.handleDrop
      }
    },
    [ this.$slots.default ]
  )
}

function renderIcon(h) {
  return h(
    components.icon,
    {
      props: {
        value: icons.attach_file,
        color: Colors.primary,
        size: 64
      }
    }
  )
}
function renderText(h) {
  return h(
    'div',
    {
      class: 'file-drop__text'
    },
    [
      h(
        'div',
        {
          class: 'file-drop__title'
        },
        [ this.getTranslate('files.dropTitle') ]
      ),
      h(
        'div',
        {
          class: 'file-drop__description'
        },
        [ this.getTranslate('files.select') ]
      )
    ]
  )
}
function renderAction(h) {
  return h(
    'div',
    {
      class: 'file-drop__action'
    },
    [ renderButton.call(this, h) ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: {
        'file-drop__body': true,
        'file-drop__body--active': this.isDragActive,
        'file-drop__body--disabled': this.isDisabled
      },
      on: {
        click: this.handleClick,
        dragenter: this.activateDropArea,
        dragover: this.activateDropArea,
        dragleave: this.deactivateDropArea,
        dragend: this.deactivateDropArea,
        drop: this.handleDrop
      }
    },
    [
      renderIcon.call(this, h),
      renderText.call(this, h),
      renderAction.call(this, h)
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: {
        'file-drop': true,
        'file-drop--disabled': this.isDisabled
      }
    },
    [ renderBody.call(this, h) ]
  )
}

export default function(h) {
  switch (this.type) {
    case 'button': return renderButton.call(this, h)
    case 'drop': return renderTrigger.call(this, h)
    default: return renderContent.call(this, h)
  }
}
